export const NAV_HEIGHT = 64
export const SIDEBAR_WIDTH = 292

export const pageLinks = [
  { href: '/contact', label: 'Contact' },
  { href: '/pages/faqs', label: 'Faqs' },
  { href: '/perks', label: 'Perks' },
  { href: '/pages/privacy', label: 'Privacy Policy' },
  { href: '/pages/terms', label: 'Terms of Use' },
]
